module.exports = __webpack_public_path__ + "static/media/eye-icon.cfdadc05.svg";